<div data-cy="support-center-container" class="support-center-container">
  <div class="main-content" data-cy="support-center-main-content">
    <span data-cy="support-center-message">
      {{ 'i18n.supportCenter.card.popover' | translate }}
    </span>
  </div>
</div>
